import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect } from '../../../../StyledComponents';

export const Schema =  Yup.object().shape({
    handicap: Yup.string().required("Angabe ist erforderlich")
  });

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
          <Form.Group className="mb-3" controlId="formhandicap">
                    <Form.Label>Liegt bei Ihnen eine Behinderung oder Schwerbehinderung gemäß SGB IX vor?</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="handicap"
                        value={values.handicap}
                        isValid={touched.handicap && !errors.handicap}
                        isInvalid={touched.handicap && errors.handicap}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Handicap.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.handicap}
                    </Form.Control.Feedback>
                </Form.Group>

        </>
    );
};






